function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  x: "-40.7%",
  y: "-469.8%",
  width: "181.3%",
  height: "1039.6%",
  filterUnits: "objectBoundingBox",
  id: "filter-1"
}, React.createElement("feGaussianBlur", {
  stdDeviation: 3.2,
  in: "SourceGraphic"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "check-an-address",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Outage-details---main-outage",
  transform: "translate(-295.000000, -60.000000)"
}, React.createElement("g", {
  id: "Group-3",
  transform: "translate(32.000000, 60.000000)"
}, React.createElement("g", {
  id: "Map-Icon/Gas/Unexpected-(Large)",
  transform: "translate(262.000000, 0.000000)"
}, React.createElement("g", {
  id: "Group-7",
  strokeWidth: 1
}, React.createElement("g", {
  id: "Group-5-Copy-6"
}, React.createElement("g", {
  id: "Group-3",
  transform: "translate(0.000000, 4.086957)"
}, React.createElement("g", {
  id: "Group-Copy"
})), React.createElement("ellipse", {
  id: "Oval-17",
  fill: "#000840",
  opacity: 0.549906716,
  filter: "url(#filter-1)",
  cx: 17.8785751,
  cy: 43.9347826,
  rx: 11.8066062,
  ry: 1.02173913
}), React.createElement("g", {
  id: "droplet-background",
  transform: "translate(1.349326, 0.000000)"
}, React.createElement("path", {
  d: "M16.1919171,0 C7.28621877,0 0,7.28083189 0,16.2414881 C0,19.7887133 1.16927231,23.148362 3.23838342,25.9488658 L15.4722764,42.5631172 C15.7422856,42.9370753 16.3715394,43.0302661 16.7319355,42.7500962 C16.8217467,42.6569054 16.8217467,42.6569054 16.9115579,42.5631172 L29.1454508,25.9488658 C31.2145619,23.148362 32.3838342,19.7887133 32.3838342,16.2414881 C32.3838342,7.28083189 25.0976155,0 16.1919171,0 Z",
  id: "Page-1",
  fill: "#ff6c0e"
}), React.createElement("ellipse", {
  id: "inner-background",
  fill: "#000840",
  cx: 16.2357069,
  cy: 16.4052861,
  rx: 12.5246881,
  ry: 12.6452861
})))), React.createElement("path", {
  d: "M16.7543629,24.098588 C16.6566823,24.098588 16.5584513,24.0702063 16.4726024,24.0104697 C16.2527522,23.8574791 16.2007475,23.5577149 16.3562111,23.3417442 L21.3098583,16.4747382 C19.0557741,16.4814957 13.5595178,16.4969029 13.5595178,16.4969029 L13.558142,16.4969029 C13.3765385,16.4969029 13.2100687,16.3979726 13.1255956,16.2398463 C13.0413976,16.0814497 13.0532293,15.8900763 13.1577889,15.7433027 L18.3797139,8.37948283 C18.5332514,8.16161994 18.8378499,8.10891117 19.059076,8.26000963 C19.280302,8.41137839 19.3345079,8.71006139 19.1806953,8.92765398 L14.4950508,15.5349004 C16.7262969,15.5286834 22.1697232,15.5132763 22.2555721,15.5132763 C22.4382762,15.5132763 22.6055715,15.6135581 22.6894943,15.7727656 C22.7728668,15.9322434 22.7596593,16.123887 22.6542742,16.2701201 L17.1533402,23.8964025 C17.058136,24.0283096 16.9073501,24.098588 16.7543629,24.098588",
  id: "Fill-109",
  fill: "#FFFFFF"
})))));

var SvgMapPin = function SvgMapPin(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "34px",
    height: "52px",
    viewBox: "0 0 34 52",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMapPin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MapPin.87bfe0b4.svg";
export { ForwardRef as ReactComponent };